import React from "react";
import PropTypes from "prop-types";
import { Badge, Card } from "@opendate-app/setlist";
import { CARD_STATUS_COLORS, CARD_STATUS_LABELS, formatDate } from "../../GiftCards/giftCardLabels";
import { formatCents } from "../../GiftCardProducts/giftCardFormat";
import { giftCardShape } from "../myGiftCardPropTypes";

export const expiryText = ({ expiresAt, expiredCents, expiredAt, currency }) => {
  if (expiredCents > 0) return `${formatCents(expiredCents, currency)} expired ${formatDate(expiredAt)}`;

  return expiresAt ? `Expires ${formatDate(expiresAt)}` : "Never expires";
};

export const GiftCardArt = ({ giftCard }) => (
  <div
    className="my-gift-card-art"
    style={giftCard.artworkUrl ? { backgroundImage: `url(${giftCard.artworkUrl})` } : undefined}
  >
    <span className="my-gift-card-art-brand">{giftCard.brandName}</span>
    <span className="my-gift-card-art-last4">•••• {giftCard.last4}</span>
  </div>
);

GiftCardArt.propTypes = { giftCard: giftCardShape.isRequired };

const GiftCardTile = ({ giftCard, onOpen }) => (
  <button type="button" className="my-gift-card-tile" onClick={() => onOpen(giftCard.id)}>
    <Card padding="none">
      <GiftCardArt giftCard={giftCard} />
      <div className="my-gift-card-tile-body">
        <div className="my-gift-card-tile-row">
          <span className="my-gift-card-tile-brand">{giftCard.brandName}</span>
          <Badge color={CARD_STATUS_COLORS[giftCard.status]} size="sm">
            {CARD_STATUS_LABELS[giftCard.status] || giftCard.status}
          </Badge>
        </div>
        <div className="my-gift-card-tile-reach">{giftCard.whereItWorks}</div>
        <div className="my-gift-card-tile-row">
          <span className="my-gift-card-tile-balance">{formatCents(giftCard.balanceCents, giftCard.currency)}</span>
          <span className="my-gift-card-tile-expiry">{expiryText(giftCard)}</span>
        </div>
      </div>
    </Card>
  </button>
);

GiftCardTile.propTypes = {
  giftCard: giftCardShape.isRequired,
  onOpen: PropTypes.func.isRequired,
};

export default GiftCardTile;
